export default (typeIds = [], studentTypeId = null) => {
  const students =
    typeIds.length > 0 && studentTypeId !== null
      ? typeIds.filter(item => item === studentTypeId)
      : [];
  return students.length > 0;
};
